// API Configuration
// В development режиме используется proxy из package.json (http://localhost:5000)
// В production режиме используется относительный путь (сервер раздаёт статику)

// Базовый URL для API (для fetch запросов - используем относительные пути)
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Полный URL сервера (для редиректов, где нужен абсолютный URL)
// В development: http://localhost:5000
// В production: домен вашего сервера
export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 
  (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000');

// Определяем URL для форм заявок
export const getFormsUrl = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const hostname = window.location.hostname;
  const port = window.location.port;
  
  if (isDevelopment) {
    // Локально: если порт 3001 или hostname содержит forms - это формы
    if (port === '3001' || hostname.includes('forms')) {
      return `${window.location.protocol}//${hostname}:${port || '3001'}`;
    }
    // Иначе возвращаем URL для форм (порт 3001)
    return `${window.location.protocol}//${hostname}:3001`;
  } else {
    // Продакшн: проверяем поддомен или используем переменную окружения
    if (hostname.includes('forms.')) {
      return `${window.location.protocol}//${hostname}`;
    }
    // Используем переменную окружения
    const formsUrl = process.env.REACT_APP_FORMS_URL;
    if (formsUrl) {
      return formsUrl;
    }
    // Автоматически формируем из текущего домена (заменяем первый поддомен на forms)
    const protocol = window.location.protocol;
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      return `${protocol}//forms.${parts.slice(1).join('.')}`;
    }
    return `${protocol}//forms.${hostname}`;
  }
};

// Функция для создания полного URL API
export const getApiUrl = (endpoint) => {
  const path = endpoint.startsWith('/api') ? endpoint : `/api${endpoint.startsWith('/') ? '' : '/'}${endpoint}`;
  return `${API_BASE_URL}${path}`;
};

// URL для редиректов (OAuth и т.д.) - нужен полный URL
export const getServerUrl = (path) => {
  return `${SERVER_URL}${path}`;
};

// Проверка, находимся ли мы на поддомене форм
export const isFormsSubdomain = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const hostname = window.location.hostname;
  const port = window.location.port;
  
  if (isDevelopment) {
    return port === '3001' || hostname.includes('forms');
  } else {
    return hostname.includes('forms.');
  }
};

export default {
  API_BASE_URL,
  SERVER_URL,
  getApiUrl,
  getServerUrl,
  getFormsUrl,
  isFormsSubdomain
};

